import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable3 = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns3 = [
    {
      prop: 'id',
      label: i18n.t('common_words.id'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'fecha',
      label: i18n.t('common_words.date'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'hora',
      label: i18n.t('common_words.hour'),
      minWidth: 120,
      sortable: true,
    },
    /*{
      prop: "code_finca",
      label: "Código de Finca",
      minWidth: 120
    },
    {
      prop: "peso",
      label: "Peso Neto (Kg)",
      minWidth: 120
    },*/
  ];

  return { Table };
};

export default configTable3;
